import React, { useCallback, useEffect, useRef, useState } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { debounce, isEmpty } from 'lodash';

import { circle_checked } from '../../../assets/img';
import { SEARCH_TALENT_FILTER, SELECT_ALL_LABEL, TALENT_FILTERS, TALENT_FINDER_FILTER_OPTIONS } from '../../../utils/constants';
import { BasicButton } from '../../../assets/common';

let tempFilterApplied = [];

const DropdownTreeSelectContainer = (props) => {
  const {
    data,
    onChange,
    onBlur,
    onApply,
    label,
    placeholder,
    filterTabActive,
    keyWord,
    onNodeToggle,
    filterName,
    onClickSelectAll,
    minWidth,
    applyClass,
    // columns = 2,
  } = props;
  const [showApply, setShowApply] = useState(false);
  const [searchVal, setSearchVal] = useState('');
  const [applyStyle, setApplyStyle] = useState({
    width: 0,
    top: 0,
  });
  const dropdownRef = useRef(null);

  const handleOnAction = async (_node, _action) => {
    document.querySelector('.dropdown').click();
    onApply(tempFilterApplied);
    tempFilterApplied = [];
  };

  const handleCheckItemApplied = (option) => {
    return !isEmpty(tempFilterApplied) ? tempFilterApplied.filter((item) => item?.currentNode?.path === option.path).length > 0 : false;
  };

  const handleOnChange = (currentNode, selectedNodes) => {
    if (isEmpty(searchVal)) {
        onChange([{
          currentNode,
          selectedNodes,
          filterName,
        }]);
     }

    if (currentNode.label === SELECT_ALL_LABEL) {
      onClickSelectAll(currentNode.checked);
      return;
    }

    if (handleCheckItemApplied(currentNode)) {
      tempFilterApplied = tempFilterApplied.map((item) => {
        if (item?.currentNode?.label === currentNode.label) {
          return {
            currentNode,
            selectedNodes,
            filterName,
          };
        } else {
          return item;
        }
      });
    } else {
      tempFilterApplied.push({
        currentNode,
        selectedNodes,
        filterName,
      });
    }
  };

  const getClassToAlignWidth = () => {
    return minWidth ? `min-width-${minWidth}` : ``;
  };

  useEffect(() => {
    const checkDropdownContent = () => {
      const dropdownContent = dropdownRef.current.querySelector('.dropdown-content');
      setShowApply(dropdownContent !== null);
      // if (dropdownContent) {
      //   const HEIGHT_APPLY = 52;
      //   const WIDTH_SCROLL = 2;
      //   const heightInput = dropdownRef.current.querySelector('.filter_button').offsetHeight;
      //   setApplyStyle({
      //     width: Math.floor(dropdownContent.offsetWidth - WIDTH_SCROLL),
      //     top: Math.floor(dropdownContent.offsetHeight - HEIGHT_APPLY + heightInput),
      //   });
      // }
    };

    checkDropdownContent();

    const observer = new MutationObserver(checkDropdownContent);
    observer.observe(dropdownRef.current, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [dropdownRef]);

  const handleSearchChange = useCallback(
      debounce((value) => {
        return setSearchVal(value);
      }),
      []
    );
  
  useEffect(() => {
      const checkDropdownLoaded = () => {
        const searchInputElem = document.querySelector(
          '.dropdown-content input[type="text"]'
        );
        if (searchInputElem) {
          searchInputElem.addEventListener('input', (event) =>
            handleSearchChange(event.target.value)
          );
          return () => {
            searchInputElem.removeEventListener('input', (event) =>
              handleSearchChange(event.target.value)
            );
          };
        } else {
          return false;
        }
      };
  
      checkDropdownLoaded();
  
      // Optionally, you can set an interval to check periodically
      const intervalId = setInterval(checkDropdownLoaded, 1000);
  
      // Cleanup interval on component unmount
      return () => clearInterval(intervalId);
    }, [handleSearchChange]);

  const getSearchPlaceholder = (key) => {
      let tempLabel = 'Search';
      TALENT_FILTERS.forEach((item) => {
        if (item.value === key) {
          tempLabel = item.label;
        }
      });
      return `Search by ${tempLabel}`;
  };
  
  const showSearchInput = (name) => {
    return SEARCH_TALENT_FILTER.some(filter => filter === name);
  }

  const handleOnFocus = () => {
    setTimeout(() => {
      const dropdownContent = document.querySelector('.dropdown-content');
      setShowApply(dropdownContent !== null);
      if (dropdownContent) {
        const HEIGHT_APPLY = 52;
        const WIDTH_SCROLL = 2;
        dropdownContent.style.cssText = `height: ${
          dropdownContent.offsetHeight + HEIGHT_APPLY
        }px`;
        const heightInput =
          document.querySelector('.filter_button').offsetHeight;
        setApplyStyle({
          width: Math.floor(dropdownContent.offsetWidth - WIDTH_SCROLL),
          top: Math.floor(
            dropdownContent.offsetHeight - HEIGHT_APPLY + heightInput
          ),
        });
      }
    });
  };

  const handleOnBlur = () => {
    onBlur();
    setShowApply(false);
    tempFilterApplied = [];
  };

  const handleOnNodeToggle = (currentNode) => {
    onNodeToggle(currentNode);
    handleOnFocus();
  };

  // Re-init data when clear search value
  useEffect(() => {
      if (!isEmpty(tempFilterApplied)) {
        onChange(tempFilterApplied);
      }
  }, [searchVal]);

  return (
    <div className={`filter_wrapper ${applyClass}`} ref={dropdownRef} style={{ minWidth: `${minWidth}px` }}>
      <button
        className={`filter_button ${filterTabActive.includes(keyWord) ? 'active' : ''}`}
        style={{
          paddingTop: `${minWidth ? '11px' : '9px'}`,
          paddingBottom: `${minWidth ? '11px' : '9px'}`,
        }}
      >
        {filterTabActive.includes(keyWord) && <img src={circle_checked} alt="nofication" />}
        {!filterTabActive.includes(keyWord) ? placeholder : label}
      </button>
      <DropdownTreeSelect
        data={data}
        texts={{ placeholder: ``, inlineSearchPlaceholder: `${getSearchPlaceholder(filterName)}` }}
        inlineSearchInput={showSearchInput(filterName)}
        onNodeToggle={handleOnNodeToggle}
        onAction={handleOnAction}
        onChange={handleOnChange}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
        //expanded={false}
        //checked={false}
        // keepOpenOnSelect={true} 
        // showPartiallySelected={true}
        // keepTreeOnSearch={true}
        // keepChildrenOnSearch={true}
        className={
          filterName === TALENT_FINDER_FILTER_OPTIONS.AGE || filterName === TALENT_FINDER_FILTER_OPTIONS.GENDER
            ? 'mdl-demo fit-content'
            : `mdl-demo ${getClassToAlignWidth()}`
        }
        />
      {showApply && (
        <div className="btn-apply" style={{ width: `${applyStyle.width}px`, top: `${applyStyle.top}px` }}>
          <BasicButton onClick={handleOnAction} mode="teal">
            Apply
          </BasicButton>
        </div>
      )}
    </div>
  );
};

export default DropdownTreeSelectContainer;
